import React from "react";
import axios from "axios";
import { Container, Row, Col } from "shards-react";
import PageTitle from "../../components/common/PageTitle";

import AddressComponent from "../common/contacts/Address";
import TaxDataComponent from "../common/contacts/TaxData";
import ClientStructureComponent from "../common/contacts/ClientStructure";
import CreditLimitComponent from "../common/contacts/CreditLimit";
import CommentsComponent from "../common/Comments";
import MediaComponent from "../common/Media";
import HansaMediaComponent from "../common/HansaMedia";
import ClassificationDataComponent from "../common/contacts/ClassificationData";
import AldNetAccountComponent from "../common/contacts/AldNetAccount";
import BasicDataComponent from "../common/contacts/BasicData";
import CampaignComponent from "../common/contacts/Campaign";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";

import api from "../common/api";

import LinearProgress from "@material-ui/core/LinearProgress";
import Backdrop from "@material-ui/core/Backdrop";
import { userHasRole } from "../auth/UserFunctions";

class ClientForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      basic_data: {
        business_name: "",
        fantasy_name: "",
        provider_type_id: "",
        email: "",
        phone: "",
        mobile: "",
        web: "",
        group: "",
        classification: "",
        client_type_id: "",
        client_tier_id: 1,
        is_risk_client: 0,
        purchase_order: "",
        purchase_order_required: 0,
        purchase_order_due_date: "",
        purchase_order_open: 0,
        client_group_id: "",
      },
      tax_data: {
        country_id: "",
        document_number: "",
        cuit_date_verification: "",
        document_type_id: "",
        iva_type_buy_id: "",
        iva_type_sell_id: "",
        iva_type_id: "",
        client_iibb_type_id: ""
      },
      address_data: [
        {
          id: "",
          code: "",
          type: "",
          floor: "",
          departament: "",
          others: "",
          street: ""
        }
      ],
      client_structure_data: [
        { structure_type_id: "", code: "", name: "", parent_structure_id: "" }
      ],
      credit_limit_data: { first_limit: "", second_limit: "" },
      classification_data: {
        invoice_type_id: "",
        operation_type_id: "",
        client_state_type_id: "",
        client_trade_type_id: "",
        client_origin_type_id: "",
        client_iibb_type_id: ""
      },
      aldnet_account: {
        aldnet_account_code: "",
        aldnet_account_test_code: "",
        aldnet_account_number: ""
      },
      campaign_data: {
        send_survey: 1
      },
      operation_types: [],
      invoice_types: [],
      client_state_types: [],
      client_trade_types: [],
      client_origin_types: [],
      payment_deals: [],
      client_types: [],
      subcontact_types: [],
      iibb_types: [],
      places: [],
      users: [],
      client_groups: [],
      errors: false,
      errorMessage: "",
      loading: true,
      action: "new",
      dialogOpen: false,
      backdrop: false,
      cuitExists: false,
      comment: "",
      messages: {
        address_data: "",
        tax_data: "",
        basic_data: "",
        classification_data: ""
      }
    };

    this.onStructureAdded = this.onStructureAdded.bind(this);
    this.onStructureRemove = this.onStructureRemove.bind(this);
    this.handleDeleteAddress = this.handleDeleteAddress.bind(this);
    this.handleDeleteStructure = this.handleDeleteStructure.bind(this);
    this.handleNewComment = this.handleNewComment.bind(this);
    this.handleCommentSubmit = this.handleCommentSubmit.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
    this.handleWalletUpload = this.handleWalletUpload.bind(this);
  }

  async componentDidMount() {
    let address_types = await this.getAddressTypes();
    let structure_types = await this.getStructureTypes();
    let iva_types = await this.getIvaTypes();
    let iva_conditions = await this.getIvaConditions();
    let document_types = await this.getDocumentTypes();
    let countries = await this.getCountries();
    let invoice_types = await this.getInvoiceTypes();
    let client_trade_types = await this.getClientTradeTypes();
    let client_origin_types = await this.getClientOriginTypes();
    let client_state_types = await this.getClientStateTypes();
    let operation_types = await this.getOperationTypes();
    let client_iibb_types = await this.getClientIibbTypes();
    let client_types = await this.getClientTypes();
    let payment_deals = await this.getPaymentDeals();
    let users = await this.getUsers();
    let subcontact_types = await this.getSubcontactTypes();
    let client_groups = await this.getClientGroups();
    let client_tiers = await this.getClientTiers();
    this.setState({
      address_types: address_types,
      structure_types: structure_types,
      iva_types: iva_types,
      iva_conditions: iva_conditions,
      document_types: document_types,
      countries: countries,
      operation_types: operation_types,
      client_state_types: client_state_types,
      client_origin_types: client_origin_types,
      client_trade_types: client_trade_types,
      invoice_types: invoice_types,
      iibb_types: client_iibb_types,
      client_types: client_types,
      payment_deals: payment_deals,
      users: users,
      subcontact_types: subcontact_types,
      client_groups: client_groups,
      client_tiers: client_tiers
    });
    var params = this.getParams();
    var client_id = params.id;
    var view = params.view;

    if (client_id !== undefined) {
      var action = view === "1" ? "view" : "edit";
      await this.setClient(client_id);
      this.setState({ client_id: client_id });
      this.setState({ action: action });
      this.setState({ disabled: view });
    } else {
      this.setState({ action: "new" });
    }
    this.setState({ loading: false });
  }

  async setClient(id) {
    var client_data = await this.getClient(id);
    client_data = client_data[0];
    this.setState({ client_data: client_data });
    this.setState({ contact_id: client_data.contact_id });
    var client_structure_data = [];
    client_data.structure.map((val, idx) => {
      var index = "";
      if (val.parent_structure_id !== "") {
        client_data.structure.map((val2, idx2) => {
          if (val2.id === val.parent_structure_id) {
            index = idx2;
          }
        });
      }
      client_structure_data.push({
        id: val.id,
        code: val.code,
        name: val.name,
        structure_type_id: val.structure_type_id,
        parent_structure_id: index
      });
    });
    if (client_structure_data.length === 0) {
      client_structure_data.push({
        structure_type_id: "",
        code: "",
        name: "",
        parent_structure_id: ""
      });
    }
    var address_data = [];
    var places = [];
    client_data.contact.address.map((val, idx) => {
      var street_number = "";
      if (JSON.parse(val.data).address_components[0].long_name === "S/N") {
        street_number = val.number;
      }

      var place = [];
      address_data.push({
        id: val.id,
        code: val.code,
        type: val.address_type_id,
        street_number: street_number,
        floor: val.floor ? val.floor : "",
        departament: val.departament ? val.departament : "",
        others: val.others ? val.others : "",
        formattedAddress: val.formattedAddress,
        postal_code: val.postal_code
      });
      place.push(JSON.parse(val.data));
      places.push(place);
    });

    if (address_data.length === 0) {
      address_data.push({
        id: "",
        code: "",
        type: "",
        floor: "",
        departament: "",
        others: ""
      });
    }
    var taxes =
      client_data.contact.taxes !== null
        ? client_data.contact.taxes
        : {
            country_id: "",
            document_number: "",
            cuit_date_verification: "",
            document_type_id: "",
            iva_type_buy_id: "",
            iva_type_sell_id: "",
            iva_type_id: ""
          };

    var provider_id = "";
    if (client_data.providers && client_data.providers.length > 0) {
      provider_id = client_data.providers[0].id;
    }
    this.setState({
      basic_data: {
        provider_id: provider_id,
        hansa_code: client_data.contact.hansa_code,
        sap_code: client_data.sap_code ? client_data.sap_code : "",
        sap_dimension: client_data.sap_dimension
          ? client_data.sap_dimension
          : "",
        business_name: client_data.business_name,
        fantasy_name: client_data.fantasy_name,
        email: client_data.contact.email,
        phone: client_data.contact.phone,
        mobile: client_data.contact.mobile,
        web: client_data.web !== null ? client_data.web : "",
        group: client_data.group !== null ? client_data.group : "",
        client_group_id:
          client_data.client_group_id !== null
            ? client_data.client_group_id
            : "",
        classification:
          client_data.classification !== null ? client_data.classification : "",
        client_type_id: client_data.client_type_id,
        client_tier_id: client_data.client_tier_id,
        vendor_user_id: client_data.vendor_user_id,
        operator_user_id: client_data.operator_user_id,
        is_risk_client: client_data.is_risk_client,
        purchase_order: client_data.purchase_order
          ? client_data.purchase_order
          : "",
        purchase_order_required: client_data.purchase_order_required,
        purchase_order_due_date: client_data.purchase_order_due_date
          ? client_data.purchase_order_due_date
          : "",
        purchase_order_open: client_data.purchase_order_open,
        purchase_order_amount: client_data.purchase_order_amount
          ? client_data.purchase_order_amount
          : 0
      },
      tax_data: {
        country_id: taxes.country_id,
        document_number: taxes.document_number,
        cuit_date_verification: this.formatDate(taxes.cuit_date_verification),
        document_type_id: taxes.document_type_id,
        iva_type_buy_id: taxes.iva_type_buy_id,
        iva_type_sell_id: taxes.iva_type_sell_id,
        iva_type_id: taxes.iva_type_id,
        client_iibb_type_id: client_data.client_iibb_type_id
      },
      address_data: address_data,
      client_structure_data: client_structure_data,
      credit_limit_data: {
        first_limit: client_data.first_credit_limit
          ? client_data.first_credit_limit
          : 0,
        second_limit: client_data.second_credit_limit
          ? client_data.second_credit_limit
          : 0,
        payment_deadline: client_data.payment_deadline
      },
      classification_data: {
        invoice_type_id: client_data.invoice_type_id,
        operation_type_id: client_data.operation_type_id,
        client_state_type_id: client_data.client_state_type_id,
        client_trade_type_id: client_data.client_trade_type_id,
        client_origin_type_id: client_data.client_origin_type_id
      },
      aldnet_account: {
        aldnet_account_number: client_data.aldnet_account_number,
        aldnet_account_code: client_data.aldnet_account_code,
        aldnet_account_test_code: client_data.aldnet_account_test_code
      },
      campaign_data: {
        send_survey: client_data.send_survey,
        send_campaign: client_data.send_campaign,
        campaign_subcontact_type_id: client_data.campaign_subcontact_type_id
          ? parseInt(client_data.campaign_subcontact_type_id)
          : ""
      },
      places: places,
      comments: client_data.comments,
      media: client_data.media
    });

    if (!userHasRole("admin-client-blocker")) {
      // Block State filter for non admin users
      var filtered_client_state_types = this.state.client_state_types.filter(
        type => type.id !== 7
      );
      if (parseInt(client_data.client_state_type_id) !== 7) {
        this.setState({ client_state_types: filtered_client_state_types });
      }
    }
  }

  formatDate(date) {
    if (
      date === "" ||
      date === null ||
      date === "null" ||
      date === "0000-00-00 00:00:00"
    ) {
      return null;
    }
    //hansa_start_date = '2019-12-31'
    //return newDate[2]
    let fromDate = new Date(date);
    let year = fromDate.getFullYear();

    let month = fromDate.getMonth() + 1;
    month = month < 10 ? "0" + month : month;
    let day =
      fromDate.getDate() < 10 ? "0" + fromDate.getDate() : fromDate.getDate();
    //return fromDate.getFullYear() + "-" + (fromDate.getMonth()+1) + "-" + fromDate.getDate();

    return year + "-" + month + "-" + day;
  }

  getParams() {
    return this.props.match.params;
  }

  getApi(url, params) {
    const token = localStorage.getItem("userToken");
    return axios
      .get(url, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => {
        res.data = Object.values(res.data);
        return res.data;
      })
      .catch(err => {
        console.log(err);
      });
  }

  getClient(id) {
    return this.getApi(api.clients().get(id));
  }

  getAddressTypes() {
    return this.getApi(api.address_types);
  }

  getStructureTypes() {
    return this.getApi(api.structure_types);
  }

  getIvaTypes() {
    return this.getApi(api.iva_types + "?contact_type=Client");
  }

  getIvaConditions() {
    return this.getApi(api.iva_conditions);
  }

  getDocumentTypes() {
    return this.getApi(api.document_types);
  }

  getCountries() {
    return this.getApi(api.countries);
  }

  getInvoiceTypes() {
    return this.getApi(api.invoice_types);
  }

  getClientTradeTypes() {
    return this.getApi(api.client_trade_types);
  }
  getClientOriginTypes() {
    return this.getApi(api.client_origin_types);
  }
  getClientIibbTypes() {
    return this.getApi(api.client_iibb_types);
  }
  getClientStateTypes() {
    return this.getApi(api.client_state_types);
  }
  getOperationTypes() {
    return this.getApi(api.operation_types);
  }
  getClientTypes() {
    return this.getApi(api.client_types);
  }
  getClientTiers() {
    return this.getApi(api.client_tiers);
  }
  getPaymentDeals(id) {
    return this.getApi(api.payment_deals);
  }
  getUsers(id) {
    return this.getApi(api.users().index());
  }
  getSubcontactTypes() {
    return this.getApi(api.clients_subcontact_types);
  }
  getClientGroups() {
    return this.getApi(api.client_groups().index());
  }
  validateCuit = async () => {
    var cuit = this.state.tax_data.document_number;
    var cuitExists = false;
    var contacts = await this.getApi(api.contacts().validateCuit(cuit));
    if (contacts) {
      var contact = contacts.filter(
        contact => contact.id.toString() !== this.state.contact_id
      );
      if (contact[0] && contact[0].client) {
        cuitExists = true;
      }
    }
    this.setState({ cuitExists: cuitExists });
  };

  handlePlaceSearch = newPlaces => {
    var address_data = this.state.address_data;
    var code = address_data.length.toString().padStart(4, "0");
    address_data[address_data.length - 1].code = code;
    address_data.push({ id: "", code: "", type: "" });
    this.setState({ places: newPlaces, address_data: address_data });
  };

  removeItem = idx => () => {
    var address_data = this.state.address_data;
    if (address_data[idx]["id"] === "") {
      address_data = address_data.filter((s, sidx) => idx !== sidx);
      if (address_data.length === 0) {
        address_data.push({ code: "", type: "", id: "" });
      }
      var places = this.state.places;
      places = places.filter((s, sidx) => idx !== sidx);
      this.setState({ address_data: address_data, places: places });
    } else {
      this.setState({
        feature_deleted: false,
        dialogOpen: true,
        message: "Esta a punto de eliminar el domicilio. ¿Está seguro?",
        address_id: address_data[idx]["id"],
        delete_address: true,
        errors: false,
        delete_feature: false
      });
    }
  };

  handleDeleteAddress() {
    var address_data = this.state.address_data;
    var places = this.state.places;
    let self = this;

    const token = localStorage.getItem("userToken");
    axios
      .delete(api.contacts().deleteAddress(this.state.address_id), {
        params: { "address[id]": this.state.address_id },
        headers: { Authorization: `Bearer ${token}` }
      })

      .then(response => {
        self.setState({ errors: false });
        self.setState({ delete_address: false });
        address_data.map((val, idx) => {
          if (val.id === this.state.address_id) {
            address_data = address_data.filter((s, sidx) => idx !== sidx);
            places = places.filter((s, sidx) => idx !== sidx);
          }
        });
        self.setState({
          address_id: "",
          address_data: address_data,
          places: places
        });
        self.setState({ delete_address: false, feature_deleted: true });
        self.setState({ dialogOpen: true });
        self.setState({ message: "Domicilio eliminado con éxito!" });
      })
      .catch(function(error) {
        self.setState({ errors: true });
        self.setState({ delete_address: false });
        self.setState({
          message:
            "El domicilio es el único del contacto. Debe haber mas de uno para eliminarlo."
        });
        self.setState({ dialogOpen: true });
        self.setState({ address_id: "" });
      });
  }

  onStructureAdded() {
    var client_structure_data = this.state.client_structure_data;
    client_structure_data.push({
      structure_type_id: "",
      code: "",
      name: "",
      parent_structure_id: ""
    });
    this.setState({ client_structure_data: client_structure_data });
  }

  onStructureRemove(idx) {
    var client_structure_data = this.state.client_structure_data;
    if (client_structure_data[idx]["id"] === "") {
      this.setState(prevState => ({
        client_structure_data: [
          ...prevState.client_structure_data.filter((s, sidx) => idx !== sidx)
        ]
      }));
    } else {
      this.setState({
        feature_deleted: false,
        dialogOpen: true,
        message: "Esta a punto de eliminar la estructura. ¿Está seguro?",
        structure_id: client_structure_data[idx]["id"],
        delete_structure: true,
        errors: false,
        delete_feature: false
      });
    }
  }

  handleDeleteStructure() {
    var client_structure_data = this.state.client_structure_data;
    let self = this;
    const token = localStorage.getItem("userToken");
    axios
      .delete(
        api.clients().deleteStructure(this.state.structure_id),
        { params: { "client_structure[id]": this.state.structure_id } },
        { headers: { Authorization: `Bearer ${token}` } }
      )

      .then(response => {
        self.setState({ errors: false });
        self.setState({ delete_address: false });
        client_structure_data.map((val, idx) => {
          if (val.id === this.state.structure_id) {
            client_structure_data = client_structure_data.filter(
              (s, sidx) => idx !== sidx
            );
          }
        });
        self.setState({
          structure_id: "",
          client_structure_data: client_structure_data
        });
        self.setState({ delete_structure: false, feature_deleted: true });
        self.setState({ dialogOpen: true });
        self.setState({ message: "Estructura eliminada con éxito!" });
      })
      .catch(function(error) {
        self.setState({ errors: true });
        self.setState({ delete_structure: false });
        self.setState({
          message:
            "La estructura es la unica del client. Debe haber mas de uno para eliminarlo."
        });
        self.setState({ dialogOpen: true });
        self.setState({ structure_id: "" });
      });
  }

  handleChange = (event, mod) => {
    var key = event.target.name;
    var val = event.target.value;
    switch (mod) {
      case "basic_data":
        var basic_data = this.state.basic_data;
        if (key === "purchase_order_amount") {
          val = val.replace("$", "").replace(/\./g, "");
        }

        basic_data[key] = val;
        this.setState({ basic_data: basic_data });
        return "";

      case "classification_data":
        var classification_data = this.state.classification_data;
        classification_data[key] = val;
        this.setState({ classification_data: classification_data });
        return "";

      case "address_data":
        var address_data = this.state.address_data;
        var data = key.split(".");
        if (data[0] === "code") {
          address_data[data[1]].code = val;
        } else if (data[0] === "type") {
          address_data[data[1]].type = val;
        } else if (data[0] === "postal_code") {
          address_data[data[1]].postal_code = val;
        } else if (data[0] === "street_number") {
          address_data[data[1]].street_number = val;
        } else if (data[0] === "floor") {
          address_data[data[1]].floor = val;
        } else if (data[0] === "departament") {
          address_data[data[1]].departament = val;
        } else if (data[0] === "others") {
          address_data[data[1]].others = val;
        } else if (data[0] === "street") {
          address_data[data[1]].street = val;
        }
        this.setState({ address_data: address_data });
        return "";

      case "tax_data":
        var tax_data = this.state.tax_data;
        tax_data[key] = val;
        this.setState({ tax_data: tax_data });
        return "";

      case "commercial_data":
        var commercial_data = this.state.commercial_data;
        commercial_data[key] = val;
        this.setState({ commercial_data: commercial_data });
        return "";

      case "credit_limit_data":
        var credit_limit_data = this.state.credit_limit_data;
        if (key === "payment_deadline") {
          credit_limit_data[key] = val;
        } else {
          credit_limit_data[key] = parseInt(
            val
              .toString()
              .replace("$", "")
              .replace(/\./g, "")
          );
        }
        this.setState({ credit_limit_data: credit_limit_data });
        return "";

      case "client_structure_data":
        var data = key.split(".");
        var client_structure_data = this.state.client_structure_data;
        if (data[2] === "code") {
          client_structure_data[data[1]].code = val;
        } else if (data[2] === "name") {
          client_structure_data[data[1]].name = val;
        } else if (data[2] === "structure_type_id") {
          client_structure_data[data[1]].structure_type_id = val;
        } else {
          client_structure_data[data[1]].parent_structure_id = val;
        }
        this.setState({ client_structure_data: client_structure_data });
        return "";
      case "aldnet_account":
        var aldnet_account = this.state.aldnet_account;
        aldnet_account[key] = val;
        this.setState({ aldnet_account: aldnet_account });
        return "";
      case "campaign_data":
        var campaign_data = this.state.campaign_data;
        campaign_data[key] = val;
        this.setState({ campaign_data: campaign_data });
        return "";
    }
  };

  handleValidations() {
    var messages = {};
    var errorMessage = "";

    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var isEmailValid = re.test(
      String(this.state.basic_data.email).toLowerCase()
    );
    errorMessage =
      "Debe completar los siguientes campos: Razón social, nombre comercial, tipo de proveedor y email válido.";

    messages.basic_data =
      this.state.basic_data.business_name !== "" &&
      this.state.basic_data.fantasy_name !== "" &&
      this.state.basic_data.email !== "" &&
      this.state.basic_data.client_type_id !== "" &&
      this.state.basic_data.client_tier_id !== "" &&
      isEmailValid
        ? ""
        : errorMessage;

    var address_data_valid = true;

    if (this.state.places.length === 0) {
      messages.address_data = "Debe ingresar al menos un domicilio.";
    } else {
      this.state.places.map((val, idx) => {
        address_data_valid =
          address_data_valid &&
          this.state.address_data[idx].code !== "" &&
          this.state.address_data[idx].type !== "";
      });

      messages.address_data = address_data_valid
        ? ""
        : "Los domicilios deben tener un código y tipo de domicilio cargado.";
    }

    var cuit = this.state.tax_data.document_number;
    var regex = /-/gi;
    cuit = cuit.replace(regex, "");
    regex = /_/gi;
    cuit = cuit.replace(regex, "");

    var date = this.state.tax_data.cuit_date_verification;
    var today = new Date();
    errorMessage = "";
    if (
      this.state.tax_data.country_id === "" ||
      this.state.tax_data.document_number === "" ||
      this.state.tax_data.document_type === "" ||
      this.state.tax_data.client_iibb_type_id === ""
    ) {
      errorMessage =
        "Debe completar los siguientes campos: País, número y tipo de documento y tipo de IIBB. ";
    }
    if (cuit.length !== 11) {
      errorMessage += " El formato del cuit no es el correcto. ";
    }
    if (this.state.cuitExists) {
      errorMessage += " El CUIT ya existe. ";
    }
    if (date === "" || new Date(date).getTime() < today.getTime()) {
      errorMessage +=
        " La fecha de verificación del CUIT/CUIL debe ser mayor  al día actual";
    }

    if (
      this.state.tax_data.iva_type_id === "" ||
      this.state.tax_data.iva_type_id === undefined
    ) {
      errorMessage += "El tipo de iva es obligatorio.";
    }

    if (
      parseInt(this.state.tax_data.iva_type_id) === 5 &&
      (this.state.tax_data.iva_type_sell_id === "" ||
        this.state.tax_data.iva_type_sell_id === undefined)
    ) {
      errorMessage += "El tipo de iva ventas es obligatorio.";
    }

    /*
    if (this.state.tax_data.iva_type_buy_id === '' || this.state.tax_data.iva_type_buy_id === undefined){
      errorMessage += 'El tipo de iva compras es obligatorio.'
    }
    */

    messages.tax_data = errorMessage !== "" ? errorMessage : "";
    messages.credit_limit = "";
    if (this.state.credit_limit_data.second_limit > 0) {
      messages.credit_limit =
        this.state.credit_limit_data.first_limit >
        this.state.credit_limit_data.second_limit
          ? "El primier limite debe ser inferior al segundo limite"
          : "";
    }
    this.setState({ messages: messages });
    return (
      messages.tax_data !== "" ||
      messages.basic_data !== "" ||
      messages.address_data !== "" ||
      messages.credit_limit !== ""
    );
  }

  handleUpload(files) {
    this.setState({
      files: files
    });
  }
  handleWalletUpload(files) {
    this.setState({
      wallet_files: files
    });
  }

  handleNewComment(comment) {
    this.setState({ comment: comment });
  }

  handleCommentSubmit() {
    if (this.state.action !== "new") {
      var formData = new FormData();
      formData.set("comment", this.state.comment);
      let self = this;
      const token = localStorage.getItem("userToken");
      axios
        .post(api.clients().comment(this.state.client_id), formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`
          }
        })
        .then(response => {
          self.setState({ errors: false });
          self.setState({ dialogOpen: true, feature_deleted: true });
          self.setState({
            message: "Comentario guardado con exito!",
            comment: ""
          });
        })
        .catch(function(error) {
          self.setState({ errors: true });
          self.setState({ delete_address: false });
          self.setState({
            message:
              "No se pudo guardar tu comentario. Por favor volver a intentar"
          });
          self.setState({ dialogOpen: true });
        });
    } else {
      alert("Su comentario se agregará al guardar al cliente");
    }
  }

  unflatten(arr) {
    var tree = [],
      mappedArr = {},
      arrElem,
      mappedElem;

    // First map the nodes of the array to an object -> create a hash table.
    for (var i = 0, len = arr.length; i < len; i++) {
      arrElem = arr[i];
      mappedArr[i] = arrElem;
      mappedArr[i]["childs"] = [];
    }

    for (var id in mappedArr) {
      if (mappedArr.hasOwnProperty(id)) {
        mappedElem = mappedArr[id];
        // If the element is not at the root level, add it to its parent array of children.
        if (mappedElem.parent_structure_id) {
          mappedArr[mappedElem["parent_structure_id"]]["childs"].push(
            mappedElem
          );
        }
        // If the element is at the root level, add it to first level elements array.
        else {
          tree.push(mappedElem);
        }
      }
    }
    return tree;
  }

  handleSubmit = event => {
    this.setState({ backdrop: true });

    event.preventDefault();

    event.stopPropagation();
    if (this.handleValidations() === true) {
      this.setState({
        dialogOpen: true,
        message:
          "Hay errores en la carga o faltan carga campos. Por favor revisar",
        errors: true,
        backdrop: false
      });
    } else {
      var formData = new FormData();
      var item = this.state;

      var item = this.state.basic_data;
      for (var key in item) {
        if (
          typeof item[key] !== undefined &&
          item[key] !== null &&
          key !== "provider_type_id" &&
          key !== "fantasy_name" &&
          key !== "business_name"
        ) {
          formData.set("contact[" + key + "]", item[key]);
          //f(key, item[key])
        }
      }
      formData.set(
        "contact[document_number]",
        this.state.tax_data.document_number
      );
      formData.set(
        "contact[document_type]",
        this.state.tax_data.document_type_id
      );
      formData.set(
        "client[web]",
        this.state.basic_data.web !== "" || this.state.basic_data.web !== null
          ? this.state.basic_data.web
          : ""
      );
      formData.set(
        "client[client_group_id]",
        this.state.basic_data.client_group_id !== "" &&
          this.state.basic_data.client_group_id !== null
          ? this.state.basic_data.client_group_id
          : ""
      );
      formData.set(
        "client[classification]",
        this.state.basic_data.classification !== ""
          ? this.state.basic_data.classification
          : ""
      );
      formData.set(
        "client[business_name]",
        this.state.basic_data.business_name
      );
      formData.set("client[fantasy_name]", this.state.basic_data.fantasy_name);
      formData.set(
        "client[first_credit_limit]",
        this.state.credit_limit_data.first_limit
      );
      formData.set(
        "client[second_credit_limit]",
        this.state.credit_limit_data.second_limit
          ? this.state.credit_limit_data.second_limit
          : 0
      );
      formData.set(
        "client[payment_deadline]",
        this.state.credit_limit_data.payment_deadline
      );
      formData.set(
        "client[client_type_id]",
        this.state.basic_data.client_type_id
          ? this.state.basic_data.client_type_id
          : ""
      );
      formData.set(
        "client[client_tier_id]",
        this.state.basic_data.client_tier_id
          ? this.state.basic_data.client_tier_id
          : ""
      );
      formData.set(
        "client[vendor_user_id]",
        this.state.basic_data.vendor_user_id
          ? this.state.basic_data.vendor_user_id
          : ""
      );
      formData.set(
        "client[operator_user_id]",
        this.state.basic_data.operator_user_id
          ? this.state.basic_data.operator_user_id
          : ""
      );
      formData.set(
        "client[is_risk_client]",
        this.state.basic_data.is_risk_client ? 1 : 0
      );
      formData.set(
        "client[purchase_order]",
        this.state.basic_data.purchase_order
          ? this.state.basic_data.purchase_order
          : ""
      );
      formData.set(
        "client[purchase_order_required]",
        this.state.basic_data.purchase_order_required ? 1 : 0
      );
      formData.set(
        "client[purchase_order_amount]",
        this.state.basic_data.purchase_order_amount
          ? this.state.basic_data.purchase_order_amount
          : ""
      );
      if (this.state.basic_data.purchase_order_required) {
        formData.set(
          "client[purchase_order_due_date]",
          this.state.basic_data.purchase_order_due_date
            ? this.state.basic_data.purchase_order_due_date
            : ""
        );
        formData.set(
          "client[purchase_order_open]",
          this.state.basic_data.purchase_order_open ? 1 : 0
        );
        formData.set(
          "client[purchase_order_open]",
          this.state.basic_data.purchase_order_open ? 1 : 0
        );
        formData.set(
          "client[send_survey]",
          this.state.campaign_data.send_survey ? 1 : 0
        );
      } else {
        formData.set("client[purchase_order_due_date]", "");
        formData.set("client[purchase_order_open]", 0);
        formData.set("client[send_survey]", 0);
      }
      var item = this.state.places;
      for (var key in item) {
        if (
          typeof item[key] != undefined &&
          item[key] != null &&
          item[key] !== ""
        ) {
          formData.set(
            "contact[address][" + key + "][code]",
            this.state.address_data[key].code
              ? this.state.address_data[key].code
              : ""
          );
          formData.set(
            "contact[address][" + key + "][address_type_id]",
            this.state.address_data[key].type
          );
          formData.set(
            "contact[address][" + key + "][country_id]",
            this.state.tax_data.country_id
          ); // address_component route 1
          //            formData.set("contact[address]["+key+"][street]", this.state.places[key][0].address_components[1].long_name); // address_component route 1
          formData.set(
            "contact[address][" + key + "][street]",
            this.state.places[key][0].address_components[1].short_name !== "AR"
              ? this.state.places[key][0].address_components[1].long_name
              : this.state.address_data[key].street
          ); // address_component route 1
          formData.set(
            "contact[address][" + key + "][number]",
            this.state.places[key][0].address_components[0].long_name === "S/N"
              ? this.state.address_data[key].street_number
              : this.state.places[key][0].address_components[0].long_name
          ); // address_component street_number 0
          //            formData.set("contact[address]["+key+"][postal_code]",(this.state.places[key][0].address_components[6])?this.state.places[key][0].address_components[6].long_name:1); // address_component postal_code 6
          formData.set(
            "contact[address][" + key + "][postal_code]",
            this.state.places[key][0].address_components[6]
              ? this.state.places[key][0].address_components[6].long_name
              : this.state.address_data[key].postal_code
          ); // address_component postal_code 6

          formData.set(
            "contact[address][" + key + "][province]",
            this.state.places[key][0].address_components[0].long_name === "S/N"
              ? this.state.places[key][0].address_components[3].long_name
              : this.state.places[key][0].address_components[4].long_name
          ); // address_component administrative_area_level_1 4
          formData.set(
            "contact[address][" + key + "][state]",
            this.state.places[key][0].address_components[0].long_name === "S/N"
              ? this.state.places[key][0].address_components[3].long_name
              : this.state.places[key][0].address_components[3].long_name
          ); // address_component administrative_area_level_1 4

          //            formData.set("contact[address]["+key+"][province]", this.state.places[key][0].address_components[4].long_name); // address_component administrative_area_level_1 4
          //            formData.set("contact[address]["+key+"][state]", this.state.places[key][0].address_components[3].long_name); // ??
          formData.set(
            "contact[address][" + key + "][lat]",
            this.state.address_data[key].id
              ? this.state.places[key][0].geometry.location.lat
              : this.state.places[key][0].geometry.location.lat()
          ); // this.state.places[key][0].geometry.location.lat()
          formData.set(
            "contact[address][" + key + "][long]",
            this.state.address_data[key].id
              ? this.state.places[key][0].geometry.location.lng
              : this.state.places[key][0].geometry.location.lng()
          ); // this.state.places[key][0].geometry.location.log()
          formData.set(
            "contact[address][" + key + "][data]",
            JSON.stringify(this.state.places[key][0])
          ); // this.state.places[key][0]

          formData.set(
            "contact[address][" + key + "][floor]",
            this.state.address_data[key].floor
              ? this.state.address_data[key].floor
              : ""
          );
          formData.set(
            "contact[address][" + key + "][departament]",
            this.state.address_data[key].departament
              ? this.state.address_data[key].departament
              : ""
          );
          formData.set(
            "contact[address][" + key + "][others]",
            this.state.address_data[key].others
              ? this.state.address_data[key].others
              : ""
          );
        }
        if (this.state.action === "edit" && this.state.address_data[key].id) {
          formData.set(
            "contact[address][" + key + "][id]",
            this.state.address_data[key].id
          );
        }
      }

      var item = this.state.classification_data;
      for (var key in item) {
        if (typeof item[key] !== undefined && item[key] !== null) {
          formData.set("client[" + key + "]", item[key]);
          //console.log(key, item[key])
        }
      }
      var item = this.state.tax_data;
      for (var key in item) {
        if (
          typeof item[key] !== undefined &&
          item[key] !== null &&
          key !== "client_iibb_type_id"
        ) {
          formData.set("tax[" + key + "]", item[key]);
          //console.log(key, item[key])
        }
      }

      formData.set(
        "client[client_iibb_type_id]",
        this.state.tax_data.client_iibb_type_id
      );

      var tree = this.unflatten(this.state.client_structure_data);
      tree.map((val, idx) => {
        if (val !== "") {
          formData.append("structure[" + idx + "]", JSON.stringify(val));
        }
      });
      /*      var item = this.state.client_structure_data

      for ( var key in item ) {
        if (typeof item[key]['code'] != undefined && item[key]['code'] !== null &&
            typeof item[key]['name'] != undefined && item[key]['name'] !== null &&
            typeof item[key]['structure_type_id'] != undefined && item[key]['structure_type_id'] !== null ){

            if (typeof item[key]['parent_structure_id'] != undefined && item[key]['parent_structure_id'] !== null && item[key]['parent_structure_id'] !== ''){

              formData.set("structure["+item[key]['parent_structure_id']+"][childs]["+key+"][code]", item[key]['code']);
              formData.set("structure["+item[key]['parent_structure_id']+"][childs]["+key+"][name]", item[key]['name']);
              formData.set("structure["+item[key]['parent_structure_id']+"][childs]["+key+"][structure_type_id]", item[key]['structure_type_id']);

            } else {
              structures.push({'code': item[key]['code'], 'name': item[key]['name'], childs:[]})
              formData.set("structure["+key+"][code]", item[key]['code']);
              formData.set("structure["+key+"][name]", item[key]['name']);
              formData.set("structure["+key+"][structure_type_id]", item[key]['structure_type_id']);
              formData.set("structure["+key+"][childs]", '');

            }

            if (this.state.action === 'edit' && item[key].id ){
              if (typeof item[key]['parent_structure_id'] !== undefined && item[key]['parent_structure_id'] !== null && item[key]['parent_structure_id']!==''){
                formData.set("structure["+item[key]['parent_structure_id']+"][childs]["+key+"][id]",item[key].id);
              } else {
                formData.set("structure["+key+"][id]",item[key].id);
              }
            }
        }
      }
*/
      var item = this.state.aldnet_account;
      for (var key in item) {
        if (typeof item[key] !== undefined && item[key] !== null) {
          formData.set("client[" + key + "]", item[key]);
          //console.log(key, item[key])
        }
      }
      var item = this.state.campaign_data;
      for (var key in item) {
        if (typeof item[key] !== undefined && item[key] !== null) {
          formData.set("client[" + key + "]", item[key]);
          //console.log(key, item[key])
        }
      }
      if (this.state.files) {
        this.state.files.map((val, idx) => {
          formData.set(`media[${idx}]`, val);
        });
      }
      if (this.state.wallet_files) {
        this.state.wallet_files.map((val, idx) => {
          formData.set(`wallet[${idx}]`, val);
        });
      }

      if (this.state.comment !== "") {
        formData.set("comment", this.state.comment);
      }

      let self = this;
      const token = localStorage.getItem("userToken");
      if (this.state.action === "new") {
        axios
          .post(api.clients().post(), formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`
            }
          })

          .then(response => {
            self.setState({ errors: false, save_client: true });
            self.setState({ message: "Cliente creado con éxito!" });
            self.setState({ dialogOpen: true });
            self.handleCloseBackdrop();
          })
          .catch(function(error) {
            self.setState({ errors: true });
            self.setState({
              message:
                "Hubo un problema al guardar el cliente. Por favor volver a intentar"
            });
            self.setState({ dialogOpen: true });
            self.handleCloseBackdrop();
          });
      } else {
        formData.set("contact[id]", this.state.contact_id);
        formData.append("_method", "patch");
        axios
          .post(api.clients().patch(this.state.contact_id), formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`
            }
          })
          .then(response => {
            self.setState({ errors: false, save_client: true });
            self.setState({ message: "Cliente modificado con éxito!" });
            self.setState({ dialogOpen: true });
            self.handleCloseBackdrop();
          })
          .catch(function(error) {
            self.setState({ errors: true, save_client: false });
            self.setState({
              message:
                "Hubo un problema al guardar el cliente. Por favor volver a intentar"
            });
            self.setState({ dialogOpen: true });
            self.handleCloseBackdrop();
          });
      }
    }
  };

  handleCloseBackdrop = () => {
    var backdrop = !this.state.backdrop;
    this.setState({ backdrop: backdrop });
  };

  render() {
    const handleRedirect = id => () => {
      window.location.href = `/clients`;
    };

    const handleDialogClose = () => {
      this.setState({
        dialogOpen: false,
        feature_deleted: false,
        delete_address: false,
        delete_structure: false,
        errors: false,
        save_client: false
      });
    };

    const disabled = this.state.disabled;

    return (
      <Container fluid className="main-content-container px-4 pb-4">
        <Row noGutters className="page-header pt-4">
          <PageTitle sm="4" title="Cliente" className="text-sm-left" />
        </Row>
        <Row>
          <Col md="12">
            <React.Fragment>
              {this.state.dialogOpen ? (
                <Dialog
                  open={this.state.dialogOpen}
                  fullWidth
                  aria-labelledby="responsive-dialog-title"
                >
                  <DialogTitle id="responsive-dialog-title">
                    {"Cliente"}
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText>{this.state.message}</DialogContentText>
                  </DialogContent>
                  <DialogActions disableSpacing="false">
                    {this.state.delete_structure ? (
                      <div>
                        <Button
                          className="mr-2"
                          onClick={this.handleDeleteStructure}
                          variant="contained"
                          color="primary"
                        >
                          Aceptar
                        </Button>
                        <Button
                          className="mr-2"
                          onClick={handleDialogClose}
                          variant="contained"
                          color="primary"
                        >
                          Cancelar
                        </Button>
                      </div>
                    ) : (
                      ""
                    )}

                    {this.state.delete_address ? (
                      <div>
                        <Button
                          className="mr-2"
                          onClick={this.handleDeleteAddress}
                          variant="contained"
                          color="primary"
                        >
                          Aceptar
                        </Button>
                        <Button
                          className="mr-2"
                          onClick={handleDialogClose}
                          variant="contained"
                          color="primary"
                        >
                          Cancelar
                        </Button>
                      </div>
                    ) : (
                      ""
                    )}

                    {this.state.errors || this.state.feature_deleted ? (
                      <Button
                        onClick={handleDialogClose}
                        variant="contained"
                        color="primary"
                      >
                        Aceptar
                      </Button>
                    ) : (
                      ""
                    )}
                    {this.state.save_client ? (
                      <Button
                        onClick={handleRedirect()}
                        variant="contained"
                        color="primary"
                      >
                        Aceptar
                      </Button>
                    ) : (
                      ""
                    )}
                  </DialogActions>
                </Dialog>
              ) : (
                ""
              )}
              {this.state.loading ? (
                <LinearProgress />
              ) : (
                <div>
                  <div className="row" className="mx-1">
                    <BasicDataComponent
                      disabled={disabled}
                      title="Datos básicos"
                      error={this.state.messages.basic_data}
                      onChange={this.handleChange}
                      basic_data={this.state.basic_data}
                      isProvider={false}
                      client_types={this.state.client_types}
                      users={this.state.users}
                      client_groups={this.state.client_groups}
                      client_tiers={this.state.client_tiers}
                    />
                  </div>

                  <div className="row" className="mx-1">
                    <AddressComponent
                      disabled={disabled}
                      error={this.state.messages.address_data}
                      address_data={this.state.address_data}
                      places={this.state.places}
                      address_types={this.state.address_types}
                      title="Direcciones"
                      onDeleteMarks={this.deleteMarkS}
                      onRemoveItem={this.removeItem}
                      onPleaceSearch={this.handlePlaceSearch}
                      onChange={this.handleChange}
                    />
                  </div>

                  <div className="row" className="mx-1">
                    <CreditLimitComponent
                      disabled={disabled}
                      credit_limit_data={this.state.credit_limit_data}
                      title="Límite de crédito"
                      onChange={this.handleChange}
                      payment_deals={this.state.payment_deals}
                    />
                  </div>

                  <div className="row" className="mx-1">
                    <TaxDataComponent
                      disabled={disabled}
                      error={this.state.messages.tax_data}
                      countries={this.state.countries}
                      tax_data={this.state.tax_data}
                      document_types={this.state.document_types}
                      iva_types={this.state.iva_types}
                      iva_conditions={this.state.iva_conditions}
                      title="Datos impositivos"
                      onChange={this.handleChange}
                      iibb_types={this.state.iibb_types}
                      cuitExists={this.state.cuitExists}
                      validateCuit={this.validateCuit}
                    />
                  </div>

                  <div className="row" className="mx-1">
                    <ClientStructureComponent
                      disabled={disabled}
                      structure_types={this.state.structure_types}
                      client_structure_data={this.state.client_structure_data}
                      title="Estructura del cliente"
                      onChange={this.handleChange}
                      onStructureRemove={this.onStructureRemove}
                      onStructureAdded={this.onStructureAdded}
                    />
                  </div>

                  <div className="row" className="mx-1">
                    <ClassificationDataComponent
                      disabled={disabled}
                      title="Clasificación"
                      error={this.state.messages.classification_data}
                      onChange={this.handleChange}
                      classification_data={this.state.classification_data}
                      operation_types={this.state.operation_types}
                      invoice_types={this.state.invoice_types}
                      client_state_types={this.state.client_state_types}
                      client_trade_types={this.state.client_trade_types}
                      client_origin_types={this.state.client_origin_types}
                    />
                  </div>

                  <div className="row" className="mx-1">
                    <AldNetAccountComponent
                      disabled={disabled}
                      title="Datos cuenta ALDNET"
                      onChange={this.handleChange}
                      aldnet_account={this.state.aldnet_account}
                    />
                  </div>

                  <div className="row" className="mx-1">
                    <CampaignComponent
                      disabled={disabled}
                      title="Envío de estados vehículos"
                      onChange={this.handleChange}
                      campaign_data={this.state.campaign_data}
                      subcontact_types={this.state.subcontact_types}
                    />
                  </div>

                  <div>
                    <CommentsComponent
                      comments={this.state.comments}
                      onChange={this.handleNewComment}
                      onSubmit={this.handleCommentSubmit}
                      disabled={this.state.disabled}
                    />
                  </div>
                  <div>
                    <MediaComponent
                      media={this.state.media}
                      onChange={this.handleUpload}
                      disabled={this.state.disabled}
                    />
                    <MediaComponent
                      media={this.state.wallet}
                      onChange={this.handleWalletUpload}
                      disabled={this.state.disabled}
                      acceptedFiles={[".pdf"]}
                      qAcceptedFiles={5}
                      title={"Documentacion App Mobile"}
                      showDelete={true}
                      onRefresh={this.onMediaRefresh}
                    />
                    <HansaMediaComponent
                      hansa_code={this.state.basic_data.hansa_code}
                      model="Client"
                    />
                  </div>
                  {this.state.action !== "view" ? (
                    <React.Fragment>
                      <Button
                        type="submit"
                        variant="contained"
                        className="mt-3 ml-1 mr-1"
                        color="primary"
                        onClick={e => this.handleSubmit(e)}
                      >
                        Guardar
                      </Button>
                      <Button
                        variant="contained"
                        className="mt-3 ml-1 mr-1"
                        color="secondary"
                        href={"/clients"}
                      >
                        Cancelar
                      </Button>
                    </React.Fragment>
                  ) : (
                    <Button
                      variant="contained"
                      className="mt-3 ml-1 mr-1"
                      color="secondary"
                      href={"/clients"}
                    >
                      Volver
                    </Button>
                  )}
                </div>
              )}
            </React.Fragment>
          </Col>
        </Row>
        <React.Fragment>
          <Backdrop
            open={this.state.backdrop}
            onClick={this.handleCloseBackdrop}
            style={{ zIndex: 10000, color: "#3f51b5" }}
          >
            <Typography className="ml-2" variant="h5" color="primary">
              Guardando...
            </Typography>
          </Backdrop>
        </React.Fragment>
      </Container>
    );
  }
}

export default ClientForm;
